import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { componentOverrides } from 'themes/componentOverrides';
import { buildGlassSurfaces, buildPalette, radius } from 'themes/tokens';
import { brandDark } from './tokens/brand';
import typography from './typography';

/**
 * InstaView dark theme — same derivation as light, reading the dark end of
 * each ramp. See themes/tokens/palette.ts for the step mapping.
 *
 * NOTE: the Figma Glass spec covers light mode only, so the glass surfaces
 * here are the light recipes and still need dark values from design.
 */
export const darkPalette = buildPalette(brandDark, 'dark', {
  // Page background is the Home tint, per the token sheet.
  surfaceFrom: 'home'
});

const instaviewCoreTheme = createTheme({
  palette: {
    ...darkPalette,
    glass: buildGlassSurfaces(darkPalette.primary.main)
  },
  radius,
  typography,
  components: componentOverrides
});

export default responsiveFontSizes(instaviewCoreTheme);
